import * as React from 'react'

const SvgHomeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.381 1.381a.625.625 0 00-.775 0L.625 8.387l.775.988 1.1-.863v7.738c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V8.519l1.1.856.775-.981-8.994-7.013zm.869 14.869h-2.5v-5h2.5v5zm1.25 0v-5c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v5H3.75V7.537L10 2.67l6.25 4.875v8.706H12.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgHomeIcon
